<template>
  <div class="container section">
    <h1 class="center" v-reveal>{{ faqs.title }}</h1>
    <accordion>
      <accordion-item
        v-for="(question, index) in faqs.questions"
        :key="index"
        v-reveal="Math.min(index * 60, 300)"
      >
        <!-- This slot will handle the title/header of the accordion and is the part you click on -->
        <template #accordion-trigger>
          <h3>{{ question.title }}</h3>
        </template>
        <!-- This slot will handle all the content that is passed to the accordion -->
        <template #accordion-content>
          <section-content :content="question" :reveal="false" />
        </template>
      </accordion-item>
    </accordion>
  </div>
</template>

<script setup>
import content from "../content.js";

import Accordion from "../components/accordion/Accordion.vue";
import AccordionItem from "../components/accordion/AccordionItem.vue";
import SectionContent from "../components/section/SectionContent.vue";

const faqs = content.sections.faqs;
</script>
